import './style.css';
import { IUserInfo } from 'globalCommon/services/getUserInfo';
import { syncRender } from 'globalCommon/services/syncRender';
import commonPageService from 'mCommon/services/commonPageService';

function callback(userInfo: IUserInfo) {
    if (userInfo && userInfo.umu_id) {
        const tryNow: any = document.querySelector('.a-operation.try-now');
        tryNow && (tryNow.href = '/');
    }
}

function init() {
    commonPageService({ cb: callback, renderAfter: syncRender });
}

init();
